import React from 'react';
import { Lock, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export function DisabledModule({ moduleName, description }) {
  return (
    <div
      className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4"
      data-testid="disabled-module"
    >
      <div className="p-4 rounded-full bg-muted/50 mb-6">
        <Lock className="h-10 w-10 text-muted-foreground/50" />
      </div>
      <h2 className="text-2xl font-bold font-outfit text-foreground mb-2" data-testid="disabled-module-title">
        Coming soon
      </h2>
      <p className="text-muted-foreground max-w-md mb-6" data-testid="disabled-module-subtitle">
        {description || "This feature is not yet enabled for your account."}
      </p>
      <a href="mailto:support@woyof.com?subject=Feature%20Request%20-%20{moduleName}">
        <Button variant="outline" data-testid="disabled-module-cta">
          Request access <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </a>
    </div>
  );
}
